import { useMediaQuery, Container, Link, Typography, Stack } from '@mui/material';
import { type Theme } from '@mui/material/styles';

export const AuthLayoutFooter = () => {
    const matchDownSM = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

    return (
        <Container maxWidth="xl">
            <Stack
                direction={matchDownSM ? 'column' : 'row'}
                justifyContent={matchDownSM ? 'center' : 'space-between'}
                spacing={2}
                textAlign={matchDownSM ? 'center' : 'inherit'}
            >
                <Typography variant="subtitle2" color="secondary" component="span">
                    This site is protected by{' '}
                    <Typography component={Link} variant="subtitle2" href="#mantis-privacy" target="_blank"
                                underline="hover">
                        Privacy Policy
                    </Typography>
                </Typography>

                <Stack direction={matchDownSM ? 'column' : 'row'} spacing={matchDownSM ? 1 : 3}
                       textAlign={matchDownSM ? 'center' : 'inherit'}>
                    <Typography
                        variant="subtitle2"
                        color="secondary"
                        component={Link}
                        href="https://codedthemes.com"
                        target="_blank"
                        underline="hover"
                    >
                        Terms and Conditions
                    </Typography>
                    <Typography
                        variant="subtitle2"
                        color="secondary"
                        component={Link}
                        href="https://codedthemes.com"
                        target="_blank"
                        underline="hover"
                    >
                        Privacy Policy
                    </Typography>
                    <Typography
                        variant="subtitle2"
                        color="secondary"
                        component={Link}
                        href="https://codedthemes.com"
                        target="_blank"
                        underline="hover"
                    >
                        CA Privacy Notice
                    </Typography>
                </Stack>
            </Stack>
        </Container>
    );
};
